<template>
  <div id="full-flyout" :class="{'full_layout':show_full_layout}">
    <div class="heading">
      <b-row class="pt-3 pb-3 pl-3 pr-3">
        <b-col>
          <slot name="page-content"></slot>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
export default {
  props: ["show_full_layout"]
};
</script>
